// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { Resources } from '@shared/localizations/Resources';
import { TerceraButton } from '../../elements/TerceraButton';
import { OperationType } from '@shared/utils/Trading/OperationType';
import { TerceraButtonStyle } from '@shared/utils/Enums/ButtonEnums';
import { ResourcesManager } from '@shared/commons/properties/ResourcesManager';
export class OEPlaceOrderButton extends TerceraButton {
    constructor() {
        super();
    }
    oninit() {
        super.oninit();
        this.observe('textLocalizationKey', this.localize);
        this.observe('side', this.onSideChanged);
        this.observe('tradingAllowed tradingForbiddenReason', this.onTradingRulesChanged);
        ResourcesManager.onLocaleChange.Subscribe(this.localize, this);
        this.localize();
    }
    dispose() {
        super.dispose();
        ResourcesManager.onLocaleChange.UnSubscribe(this.localize, this);
    }
    localize() {
        const textLocalizationKey = this.get('textLocalizationKey');
        if (isValidString(textLocalizationKey)) {
            void this.set('text', Resources.getResource(textLocalizationKey));
        }
        else {
            void this.set('text', Resources.getResource('panel.newOrderEntry.placeOrderButton'));
        }
    }
    onSideChanged(side) {
        void this.set('terceraButtonStyle', side === OperationType.Buy ? TerceraButtonStyle.Blue : TerceraButtonStyle.Red);
    }
    onTradingRulesChanged() {
        const tradingAllowed = this.get('tradingAllowed');
        const tradingForbiddenReason = this.get('tradingForbiddenReason');
        void this.set({
            enabled: tradingAllowed,
            tooltip: tradingAllowed || !isValidString(tradingForbiddenReason) ? '' : tradingForbiddenReason
        });
    }
}
TerceraButton.extendWith(OEPlaceOrderButton, {
    data: function () {
        return {
            width: 296,
            height: 32,
            side: null,
            textLocalizationKey: '',
            tradingAllowed: false,
            tradingForbiddenReason: ''
        };
    }
});
